import { sendWebsocketMessage } from '../../../../../App';

export function removeWatchlistName(name) {
  const msg = {
    messageType: 'removeWatchlistName',
    name,
  };
  sendWebsocketMessage(msg);
}
